import { Col, Row } from 'antd';
import { MFormSection, MSpinner, MyAccountLayout, MyAccountSidebarOtherMenuItemKey } from 'src/lib';
import { AccountStatusLabel } from 'src/models';

import { AccountInvestigations } from './AccountInvestigations';
import { CurrentAccountStatus } from './CurrentAccountStatus';
import { CurrentAccountStatusDescription } from './CurrentAccountStatusDescription';

export const AccountInvestigationContent = ({
  isLoading,
  status,
}: {
  isLoading: boolean;
  status?: AccountStatusLabel;
}) => {
  if (isLoading) {
    return <MSpinner />;
  }

  return (
    <MyAccountLayout sidebarMenuItemKey={MyAccountSidebarOtherMenuItemKey.AccountStatus} title='Account Status'>
      <Row>
        <Col span={24}>
          <MFormSection title={status && <CurrentAccountStatus label={status} />} isEditable={false} isEditMode={false}>
            <CurrentAccountStatusDescription />
            <AccountInvestigations />
          </MFormSection>
        </Col>
      </Row>
    </MyAccountLayout>
  );
};
